import axios from 'Axios';
import SUPPLY_DASHBOARD_DATA from 'Api/Routes';

export const getSupplyDashboardData=()=>axios.get('/supply/user/dashboard');


